import type { ComponentProps } from 'react';
import { cn } from '../lib/cn.ts';

/**
 * An unstyled, accessible button for clickable rows and cards (a list row that opens a
 * record, a stat tile that navigates). Brings the focus ring and hover surface; the
 * caller supplies layout. Use Button for actions.
 */
export function Pressable({ className, type = 'button', ...rest }: ComponentProps<'button'>) {
  return (
    <button
      type={type}
      className={cn(
        'block w-full min-w-0 text-left -outline-offset-2 transition-colors duration-(--duration-fast) ease-standard disabled:pointer-events-none disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
}
